import { z } from 'zod';
import type { TFunction } from 'i18next';

/**
 * @param areDelegationsRequired read LAZILY, at validation time, on purpose: whether the picked
 * company forces a delegation choice is only known after the company selector inside this very
 * form has been watched — i.e. after `useForm()` has already been handed this resolver. A plain
 * boolean captured here would always be one render behind the selector.
 */
export const createCompanySwitchSchema = (
	t: TFunction,
	areDelegationsRequired: () => boolean = () => false,
) =>
	z
		.object({
			company_id: z
				.number({ message: t('form_validation.required') })
				.min(1, { message: t('form_validation.required') }),
			delegations: z.array(z.number()).default([]),
		})
		.superRefine(({ delegations }, ctx) => {
			if (delegations.length > 0 || !areDelegationsRequired()) return;

			// An empty array means "the whole company" to the backend, which is exactly the
			// escalation this guards: a user who only reaches one delegation in the target company
			// would otherwise land there company-wide.
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				path: ['delegations'],
				message: t('companySwitch:delegationsRequired'),
			});
		});

export type CompanySwitchForm = z.infer<ReturnType<typeof createCompanySwitchSchema>>;
